var calculateWidgetFunction = function calculateWidgetFunction(data, widgetFunction, columnFields) {
    var expressionManipulated = widgetFunction.expressionManipulated;
    if (!expressionManipulated) expressionManipulated = widgetFunction.ExpressionManipulated;
    if (columnFields && columnFields.length > 0) {
        columnFields.forEach(function (columnField) {
            expressionManipulated = expressionManipulated.replaceAll("[" + columnField.id + "]", "[" + columnField.name + "]");
        });
        columnFields.forEach(function (columnField) {
            var propertyValue = data.hasOwnProperty(columnField.name + "_raw") ? data[columnField.name + "_raw"] : data[columnField.name];
            expressionManipulated = expressionManipulated.replaceAll("[" + columnField.name + "]", "(" + propertyValue + ")");
        });
    }
    var functionType = widgetFunction.functionType;
    if (!functionType) functionType = widgetFunction.FunctionType;
    var value = evalFunction(functionType, expressionManipulated);
    return value;
};

var evalFunction = function evalFunction(functionType, expression) {
    switch (functionType.toLowerCase()) {
        case "arithmetic":
            return evalArithmetic(expression);
        case "ifelseif":
            return evalConditional(expression);
    }
};

var evalArithmetic = function evalArithmetic(expression) {
    var value = null;
    try {
        value = eval(expression);
    } catch (e) {
        value = null;
    }
    return value;
};

var evalConditional = function evalConditional(expression) {
    if (expression.indexOf(" then ") >= 0) expression = expression.replaceAll(" then ", "){");
    if (expression.indexOf(" else ") >= 0) expression = expression.replaceAll(" else ", "} else {");
    if (expression.indexOf(" elseif ") >= 0) expression = expression.replaceAll(" elseif ", "} else if(");
    if (expression.indexOf(" endif)") >= 0) expression = expression.replaceAll(" endif)", "}");
    var value = null;
    try {
        value = eval(expression);
    } catch (e) {
        value = null;
    }
    return value;
};

export default { calculateWidgetFunction: calculateWidgetFunction };